import { useEffect, useState } from "react";
import { subscribeRuntimeContext } from "../config/runtimeAccessor";

// appState/authState (config/localStorage.js, helper/com-helper.js) are
// plain mutable snapshots kept "fresh" by subscribeRuntimeContext, not
// React state — a component that reads them directly during render has no
// way to know they later changed (e.g. AuthContext's refresh() resolving
// permissions asynchronously after a hard reload) unless it re-renders for
// some unrelated reason. Calling this hook makes the component re-render
// on every runtime-context update, so those reads stay live.
export const useRuntimeContextVersion = () => {
  const [version, setVersion] = useState(0);
  useEffect(() => subscribeRuntimeContext(() => setVersion((v) => v + 1)), []);
  return version;
};

export default useRuntimeContextVersion;
